import React, { useEffect } from "react";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";
// Styles
import "./App.css";

// Utilities
import Authentication from "./components/utils/Authentication";

import { useSelector, useDispatch } from "react-redux";
import { setScreenWidth } from "./redux/actions/general";
import ReactGA from "react-ga";

import Broadcast from "./containers/broadcast/Broadcast";
import Modal from "./components/modal/Modal";
import NotFoundPage from "./containers/notFoundPage/NotFoundPage";

const App = () => {
	const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
	const sideDrawerOpen = useSelector((state) => state.general.sideDrawerOpen);
	const dispatch = useDispatch();

	useEffect(() => {
		// Start listening for window resize
		window.addEventListener("resize", updateWindowDimensions);
		ReactGA.initialize("UA-169246854-1");
		// Remove event listener on unmount
		return () => {
			window.removeEventListener("resize", () => {});
		};
	}, []);

	// Save screen width to state
	const updateWindowDimensions = () => {
		dispatch(setScreenWidth(window.innerWidth));
	};

	return (
		<Router>
			<Authentication>
				<Modal />
				<Switch>
					<main>
						<Route path="/:facilityId">
							<Broadcast />
						</Route>
					</main>
				</Switch>
			</Authentication>
		</Router>
	);
};

export default App;
